import { useContext, useEffect, useMemo, useState } from "react";
import SecondHeader from "../Header/SecondHeader";
import EventsHead from "./EventsParts/EventsHead";
import { useSelector } from "react-redux";
import { useGetAllNotficationsQuery } from "../../Redux/service/Notifications/NewNotifications";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import { filtrationcontext } from "../../context/Filtercontext";
import trans, { isRTL } from "../../utils";
import { formatDateString } from "../../JsHelpers/DateFormat";
import { SpeedUnit } from "../../JsHelpers/PlatformUnits";
import AntdTable from "../antd/Table/Table";
import { popupcontext } from "../../context/Popupscontext";
import axios from "axios";

export default function Events() {
	const inf = useSelector((state) => state.users.user);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [selectedUser, setSelectedUser] = useState(inf.id);
	const [selectedId, setSelectedId] = useState("");
	const [oldId, setoldId] = useState("");
	const [isShown, setIsShown] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});
	const [geoCode, setGeoCode] = useState();
	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	const { form } = useContext(popupcontext);

	const { data, isFetching, isError } = useGetAllNotficationsQuery(
		{
			page: currentPage,
			limit: limit,
			search: searchQuery,
			sortby: sort.by,
			sortorder: sort.order,
			from: startDate,
			to: endDate,
			selectedid: selectedId,
		},
		{
			skip: !startDate || !endDate || !selectedId || !isShown,
		},
	);

	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
			setCurrentPage(1);
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);

	useEffect(() => {
		localStorage.setItem("page", currentPage);
	}, [currentPage, selectedId]);

	useEffect(() => {
		if (isShown && (!startDate || !endDate || !selectedId)) {
			toast.error(trans("Please select at least one date and a vehicle"), {
				autoClose: 800,
			});
			setIsShown(false);
		}
	}, [isShown, startDate, endDate, selectedId]);

	useEffect(() => {
		if (form) {
			setIsShown(false);
		}
	}, [form]);
	useEffect(() => {
		if (!isShown && data) {
			setSelectedId(null);
		}
	}, [isShown, data]);
	console.log("OldId", oldId);
	console.log("selectedId", selectedId);
	useEffect(() => {
		if (isShown && oldId !== selectedId) {
			console.log("here");
			setCurrentPage(1);
			setoldId(selectedId); // ✅ update oldId *after* comparing
		}
	}, [isShown, oldId, selectedId]);
	useEffect(() => {
		return () => {
			SetSortFilter({ type: "id", value: null });
			setCurrentPage(1);
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);
	useEffect(() => {
		return () => setSearchQuery("");
	}, [setSearchQuery]);

	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "",
				order: "",
			});
		}
	};

	const getAlertType = (type) => {
		switch (type) {
			case "deviceOverspeed":
				return "Speed Alert.";
			case "geofenceExit":
				return "Geofence exited.";
			case "geofenceEnter":
				return "Geofence entered.";
			case "deviceFuelDrop":
				return "Fuel Drop";
			case "deviceFuelIncrease":
				return "Fuel Increase";
			case "idle":
				return "Vehicle Idle";
			default:
				return type;
		}
	};
	const fetchGeoCodePosition = async (lat, lon, id) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`,
			);
			setGeoCode((prev) => ({
				...prev,
				[id]: response.data.display_name,
			}));
		} catch (error) {
			toast.error(trans("Error fetching geocode position:"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	const truncateItem = (text) => {
		const maxLength = 25;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	const Columns = [
		{
			title: trans("Name"),
			dataIndex: "device",
			width: 150,
			fixed: !isRTL ? "left" : undefined,
			render: (device) => (
				<span className={"table-element-name ps-0"}>{device?.name}</span>
			),
		},

		{
			title: trans("Imei"),
			dataIndex: "device",
			width: 150,
			fixed: !isRTL ? "left" : undefined,
			render: (device) => (
				<span className={""} title={device?.uniqueIds}>
					{truncateItem(device?.uniqueId)}
				</span>
			),
		},
		{
			title: trans("Type"),
			dataIndex: "type",
			width: 150,
			render: (type) => <span className={""}>{trans(getAlertType(type))}</span>,
		},
		{
			title: trans("Geofence"),
			dataIndex: "geofence",
			width: 150,
			render: (geofence) => <span>{geofence?.name || "- - - - - -"}</span>,
		},
		{
			title: trans("Date"),
			dataIndex: "time",
			width: 150,
			sorter: true,
			render: (time) => <span>{formatDateString(time)}</span>,
		},
		{
			title: trans("Speed"),
			dataIndex: "attributes",
			width: 150,
			render: (attributes) =>
				attributes.speed ? (
					<span>
						{SpeedUnit(attributes.speed, inf?.attributes?.speedUnit || "kn")}
					</span>
				) : (
					"- - - - -"
				),
		},
		{
			title: trans("Speed Limit"),
			dataIndex: "attributes",
			width: 150,
			render: (attributes) =>
				attributes.speedLimit ? (
					<span>
						{SpeedUnit(
							attributes.speedLimit,
							inf?.attributes?.speedUnit || "kn",
						)}
					</span>
				) : (
					"- - - - -"
				),
		},
		{
			title: trans("Address"),
			dataIndex: "position",
			width: 150,
			render: (position) =>
				position?.latitude && position?.longitude ? (
					<span
						onClick={() =>
							fetchGeoCodePosition(
								position?.latitude,
								position?.longitude,
								position?.id,
							)
						}
						title={geoCode?.[position?.id]}
						className="text-primary cursor"
					>
						{geoCode?.[position?.id]
							? truncateItem(geoCode[position?.id])
							: trans("Get current address")}
					</span>
				) : (
					"- - - - -"
				),
		},
	];

	if (isError) toast.error(trans("Please try again"));

	return (
		<div>
			<Helmet>
				<title>Notifications</title>
				<meta name="description" content="Notifications" />
			</Helmet>
			<SecondHeader title={trans("notifications")} />
			<EventsHead
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
				selectedUser={selectedUser}
				setSelectedUser={setSelectedUser}
				selectedId={selectedId}
				setSelectedId={setSelectedId}
				isShown={isShown}
				setIsShown={setIsShown}
			/>
			<div className="events-table">
				<div className="bg-white-rounded-top table-parent">
					<AntdTable
						columns={Columns}
						dataSource={data?.data || []}
						loading={isShown && isFetching}
						pageSize={limit}
						totalItems={data?.totalCount || 0}
						onPageChange={(page) => setCurrentPage(page)}
						onLimitChange={(newLimit) => {
							setLimit(newLimit);
							setCurrentPage(1);
						}}
						currentPage={currentPage}
						onTableChange={handleTableChange}
					/>
				</div>
			</div>
		</div>
	);
}
